import React, { useState } from 'react';
import { Typography, OutlinedInput, InputAdornment, IconButton, OutlinedInputProps } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { sxLabel, sxValidationMessage } from './sxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

interface PasswordInputProps extends OutlinedInputProps {
    label: string;
    textError?: string;
    maxLength: number;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
    id,
    label,
    placeholder,
    name,
    error,
    textError,
    maxLength = 30,
    onChange,
    ...props
}) => {

    const { textStyleAccessibility } = useAccessibility();
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className='width-100'>
            <Typography 
                style={textStyleAccessibility} 
                sx={sxLabel}
            >{label}</Typography>
            <label htmlFor={id} aria-label={label} />
            <OutlinedInput
                id={id}
                aria-describedby={`err-${name}`}
                fullWidth
                type={showPassword ? 'text' : 'password'}
                placeholder={placeholder}
                name={name}
                onChange={onChange}
                error={!!error}
                inputProps={{ maxLength }}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            aria-label={!showPassword ? 'Exibir senha' : 'Ocultar senha'}
                            onClick={handleShowPassword}
                            edge="end"
                        >
                            {showPassword ? (
                                <FontAwesomeIcon className='icon-login-color' fontSize={16} icon={faEyeSlash as IconDefinition} />
                            ) : (
                                <FontAwesomeIcon className='icon-login-color' fontSize={16} icon={faEye as IconDefinition} />
                            )}
                        </IconButton>
                    </InputAdornment>
                }
                {...props}
            />
            {textError && (
                <div className='container-validation-message'>
                    <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
                    <Typography id={`err-${name}`} sx={sxValidationMessage} style={textStyleAccessibility}>
                        {textError}
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default PasswordInput;
